import { Form } from '@/helpers/Form';
import Pager from '@/helpers/Pager';

export default {
    namespaced: true,
    state: {
        filter: Form.create({
            user: null,
            companyId: null,
            isActive: null
        }),
        pager: new Pager(1, 20, 'DateModifiedUtc', 'DESC')
    }
};
